<template>
  <div class="popup-wrap p-cart-quantity-info" :class="{ active: active }">
    <div class="popup p-cart-quantity-info active">
      <div class="close-btn" @click.prevent.stop="triggerHide"></div>
      <div class="p-head">{{ title }}</div>
      <div class="p-body no-brdb tac">
        <div class="p-line">
          <span v-html="text" />
        </div>
        <div class="p-line">
          <div class="order_button basket_custom_btn p-chose-btn" @click.prevent.stop="triggerHide">{{ close }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    limit: Number,
  },
  computed: {
    title() {
      return BX.message('KZ_BASKET_QUANTITY_OVERFLOW_TITLE');
    },
    text() {
      return BX.message('KZ_BASKET_QUANTITY_OVERFLOW_TEXT').replace('#QUANTITY_OVERFLOW_LIMIT#', this.limit);
    },
    close() {
      return BX.message('KZ_BASKET_QUANTITY_OVERFLOW_CLOSE');
    },
  },
  methods: {
    triggerHide() {
      this.$emit('close');
    }
  }
}
</script>
